import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api from "../../../api/Api.js";
import { Link, redirect, useNavigate } from "react-router-dom";
import { ArrowLeft,Search } from "lucide-react";
import Swal from "sweetalert2";

const TabManage = () => {

  const navigate = useNavigate();
const [searchTerm, setSearchTerm] = useState("");
  const [getTab, setTab] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);

  // =========================
  // FETCH CATEGORY DATA
  // =========================

  useEffect(() => {
    fetchTabData();
  }, []);

  const fetchTabData = async () => {
    try {
      const res = await api.get("/adminHolidays/get-holidays-tab-data");
      setTab(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Tab data");
    }
  };

  // =========================
  // DELETE CATEGORY
  // =========================

  const handleDelete = async (id) => {

    const confirm = await Swal.fire({
      title: "Delete Tab?",
      text: "Do you want to delete this Tab?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes Delete"
    });

    if (!confirm.isConfirmed) return;

    try {

      const res = await api.delete(
        `/adminHolidays/holidays-tab-delete/${id}`
      );

      if (res.data.success) {
        Swal.fire("Deleted!", "Tab deleted successfully", "success");
        fetchTabData();
      }

    } catch (error) {
      toast.error("Failed to delete Tab");
    }

  };

  // =========================
  // STATUS CHANGE
  // =========================

  const handleStatusChange = async (id, status) => {

    try {

      await api.put("/adminHolidays/holidays-tab-status", {
        id,
        status
      });

      toast.success("Status updated");
      fetchTabData();

    } catch (error) {
      toast.error("Failed to update status");
    }

  };



const handleEditTab = (tabId) => {
  navigate(`/holidays/tabs/edit-tabs/${tabId}`);
};


const updateSortOrder = async (id, sort_order) => {
  try {
    await api.put("/adminHolidays/update-tab-sort-order", {
      id,
      sort_order,
    });

    toast.success("Sort order updated");
    fetchTabData();
  } catch (error) {
    toast.error("Failed to update sort order");
  }
};
  // =========================
  // PAGINATION
  // =========================

  // const indexOfLast = currentPage * perPage;
  // const indexOfFirst = indexOfLast - perPage;
  // const currentItems = getTab.slice(indexOfFirst, indexOfLast);
  // const totalPages = Math.ceil(getTab.length / perPage);

  // =========================
  // FILTER & SEARCH
  // =========================
  const filteredCountries = getTab.filter((cat) => {
    const term = searchTerm.trim().toLowerCase();

    const countryName = String(cat.name || "").toLowerCase();
    const countrySlug = String(cat.slug || "").toLowerCase();

    return (
      countryName.includes(term) ||
      countrySlug.includes(term)
    );
  });

  // =========================
  // PAGINATION
  // =========================
  const totalPages = Math.ceil(filteredCountries.length / perPage);

  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;

  const currentItems = filteredCountries.slice(
    indexOfFirst,
    indexOfLast
  );

  // Search change hone par first page par jaayein
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  // =========================
  // JSX
  // =========================

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between">
          <h4 className="fw-bold">Manage Tabs</h4>
<div style={{display:"flex"}}>
<div className="input-group input-group-sm" style={{width: '200px',marginRight:"10px"}}>
                <span className="input-group-text bg-white"><Search size={16}/></span>
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Search..." 
                  value={searchTerm} 
                  onChange={handleSearch}
                />
</div>
          <Link
            to={"/holidays/tabs/add-tabs"}
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} /> Add Tab
          </Link>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm border-0">
        <div className="table-responsive">

          <table className="table table-hover table-sm align-middle mb-0">

            <thead className="bg-light">
              <tr>
                <th>Sl</th>
                <th  style={{width:"80px"}}> Sort</th>
                <th>Tab Name</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-muted">
                    No Tab Found
                  </td>
                </tr>
              ) : (

                currentItems.map((tab, index) => (

                  <tr key={tab.tab_id}>

                    <td>{indexOfFirst + index + 1}</td>
                    <td>
<input
  type="number"
  className="form-control form-control-sm"
  defaultValue={tab.sort_order}
  onBlur={(e) =>
    updateSortOrder(tab.tab_id, e.target.value)
  }

/>
</td>
                    <td>{tab.name}</td>

                    <td>{tab.slug}</td>

                    {/* STATUS */}
                 <td>
<select
      className={`form-select form-select-sm ${
        tab.status == 1 ? "text-success" : "text-danger"
      }`}
      value={tab.status}
      onChange={(e) =>
        handleStatusChange(tab.tab_id, e.target.value)
      }
    >
      <option value="1">Active</option>
      <option value="0">Inactive</option>
    </select>
</td>

                    {/* ACTION */}
                    <td>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => handleEditTab(tab.tab_id)}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(tab.tab_id)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}
        <div className="d-flex justify-content-center mt-3">
          <ul className="pagination">

            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                Prev
              </button>
            </li>

            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}

            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                Next
              </button>
            </li>

          </ul>
        </div>

      </div>

    </div>
  );
};

export default TabManage;